import { core } from '@musinsa/pbo-core'

interface Props {
  open: boolean
  title: string
  message: string
  barcodes: string[]
  onClose: () => void
}

/**
 * SKU 미해소 차단 모달. 1.0 `SkuFailModal`(LOGISPRD-10930) 동치.
 *
 * 저장·확정 둘 다 422 + `errorCode: ERROR_OUTBOUND_SKU_UNMAPPED` 로 같은 응답을 주므로 모달도 공용이다.
 * 막힌 바코드는 잘라 보여주지 않는다 — 담당자가 SCM Hub 에 등록할 목록이라 빠지면 다시 올려도 또 막힌다.
 * 표는 그대로 두고 모달만 닫는다. 담당자가 그 행을 고쳐 다시 저장해야 한다.
 */
export function SkuUnmappedModal({ open, title, message, barcodes, onClose }: Readonly<Props>) {
  return (
    <core.Modal
      open={open}
      title={title}
      width={520}
      onCancel={onClose}
      footer={
        <core.Button type="primary" onClick={onClose}>
          확인
        </core.Button>
      }
    >
      <core.Flex vertical gap={12} align="stretch">
        <core.Typography.Text>{message}</core.Typography.Text>
        <div style={{ maxHeight: 320, overflowY: 'auto', border: '1px solid #f0f0f0', borderRadius: 4, padding: 12 }}>
          {barcodes.map((barcode) => (
            <div key={barcode} style={{ lineHeight: '22px' }}>
              {barcode}
            </div>
          ))}
        </div>
      </core.Flex>
    </core.Modal>
  )
}
